var map = {
	"./1-ball.png": 577,
	"./10-ball.png": 704,
	"./11-ball.png": 894,
	"./12-ball.png": 895,
	"./13-ball.png": 896,
	"./14-ball.png": 897,
	"./15-ball.png": 898,
	"./2-ball.png": 578,
	"./3-ball.png": 579,
	"./4-ball.png": 580,
	"./5-ball.png": 581,
	"./6-ball.png": 582,
	"./7-ball.png": 583,
	"./8-ball.png": 584,
	"./9-ball.png": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;